<!--
  Diagnostic transparency: persistent in-app banner removed at product
  request. The active state remains clearly visible in
  Configurations → Aide au support technique (yellow "⚠️ Actif: …
  jusqu'au …" inside the same toggle row), which is the canonical
  control surface — compliant with Apple 5.1 / Google Play User Data
  as long as the status is discoverable and the toggle is revocable.
-->
<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
